import React from "react";

function DisabledList({ features, pre }) {
  if (features)
    return (
      <React.Fragment>
        {pre || "The following Molstack features have been disabled:"}
        <ul>
          {features.map(feature => (
            <li>{feature.name}</li>
          ))}
        </ul>
      </React.Fragment>
    );
  else return null;
}

const dialogs = {
  unsupported: {
    title: "Your web browser is unsupported",
    getMessage: context => (
      <React.Fragment>
        Your browser (<b>{context.browser}</b>) is{" "}
        {context.outdated ? "outdated." : "currently not supported and tested."}
        {context.disabledFeatures > 0 ? (
          <React.Fragment>
            <DisabledList features={context.disabledFeatures} />
            Other features may not work correctly.
          </React.Fragment>
        ) : (
          " Some features may not work correctly."
        )}
      </React.Fragment>
    )
  },
  nowebgl: {
    title: "Unable to load WebGL context",
    getMessage: context => (
      <React.Fragment>
        Molstack requires browser with WebGL support. Please consult:{" "}
        <a href="https://get.webgl.org/"> get.webgl.org </a>
      </React.Fragment>
    )
  },
  disabledFeatures: {
    title: "Some Molstack features are disabled",
    getMessage: context => (
      <React.Fragment>
        <DisabledList
          pre="Your browser does not support the following Molstack features:"
          features={context.disabledFeatures}
        />
        These features have been disabled, but Molstack should work correctly.
      </React.Fragment>
    )
  }
};

export default dialogs;
